module.exports = __webpack_public_path__ + "static/media/direct_link.518addd1.svg";